import { render, staticRenderFns } from "./yiXinApplicationEdit.vue?vue&type=template&id=72cfd546&"
import script from "./yiXinApplicationEdit.vue?vue&type=script&lang=js&"
export * from "./yiXinApplicationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports